import type { Template } from "@/types";

export const PO_03_H3_V0: Template[] = [
    {
        id: "po-03-h3v0-01",
        name: "PO 01 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 290, width: 389, height: 247, rotation: 0, imageRotation: 0 },
            { id: "2", x: 455, y: 290, width: 389, height: 247, rotation: 0, imageRotation: 0 },
            { id: "3", x: 852, y: 290, width: 388, height: 247, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-02",
        name: "PO 02 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 277, width: 428, height: 271, rotation: 0, imageRotation: 0 },
            { id: "2", x: 436, y: 277, width: 427, height: 271, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 277, width: 427, height: 271, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-03",
        name: "PO 03 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 67, y: 82, width: 515, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 417, width: 515, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 715, y: 250, width: 515, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-04",
        name: "PO 04 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 67, y: 82, width: 515, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 417, width: 515, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 649, y: 208, width: 649, height: 409, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-05",
        name: "PO 05 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_05.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 106, y: 165, width: 357, height: 246, rotation: 0, imageRotation: 0 },
            { id: "2", x: 106, y: 419, width: 357, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 471, y: 165, width: 722, height: 499, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-06",
        name: "PO 06 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 288, y: 94, width: 722, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 497, width: 357, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 653, y: 497, width: 357, height: 236, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-07",
        name: "PO 07 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_07.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 0, y: 116, width: 385, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 417, width: 385, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 393, y: 116, width: 905, height: 594, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-08",
        name: "PO 08 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_08.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 61, y: 145, width: 347, height: 265, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 418, width: 347, height: 265, rotation: 0, imageRotation: 0 },
            { id: "3", x: 416, y: 145, width: 822, height: 538, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-09",
        name: "PO 09 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 118, y: 180, width: 746, height: 468, rotation: 0, imageRotation: 0 },
            { id: "2", x: 872, y: 180, width: 309, height: 230, rotation: 0, imageRotation: 0 },
            { id: "3", x: 872, y: 418, width: 309, height: 230, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-10",
        name: "PO 10 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 68, y: 250, width: 515, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 716, y: 82, width: 515, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 716, y: 417, width: 515, height: 326, rotation: 0, imageRotation: 0 }
        ],
    }
];